import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-base-divider",
  "aria-orientation": "horizontal",
  role: "separator"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("hr", _hoisted_1))
}